module.exports = __webpack_public_path__ + "img/hero-image.3fa63b56.png";